import React from 'react'
import {
  EmarModuleCard,
  FamilyPlanModuleCard,
} from '@lmc/ui-kit'
import { PaywallTemplateWrapper } from '../../../../../components/generic/PaywallTemplateWrapper'
import { colors } from '@lmc/common/constants'
import { IconType } from '@lmc/ui-kit'
import { colours } from '@lmc/ui-kit/src/config/theme'

interface StateProps {
}

const RiskAssessmentPaywallComponent: React.FC<StateProps> = () => {
  return (
    <PaywallTemplateWrapper
      backgroundColor={colours.status.popout}
      title="Risk assessments"
      subTitle="Mitigate risks and protect service users and carers from harm. Choose from over 40 common templates or create your own. You’ll spot high-risk situations in seconds with our auto-generated risk score."
      bodyText="Evidence safe and effective care."
      icon={IconType.CarePlansHexagon}
      videoUrl="https://www.youtube.com/embed/SqXLg3_2COw"
      articles={[
        {
          title: 'How do I add a risk assessment?',
          subtitle: 'View Article',
          icon: 'SettingOutlined',
          id: 'testId1',
          link: 'https://support.logmycare.co.uk/en/collections/1943707-care-plans-and-assessments-module',
          iconBackgroundColour: colors.orange,
          iconColour: colors.white,
        },
        {
          title: 'What is the risk assessment dashboard?',
          subtitle: 'View Article',
          icon: 'QuestionCircleOutlined',
          id: 'testId2',
          link: 'https://support.logmycare.co.uk/en/articles/3371486-risk-assessment-dashboard',
          iconBackgroundColour: colors.green,
          iconColour: colors.white,
        },
        {
          title: 'What other features do I get with Pro?',
          subtitle: 'View Article',
          icon: 'UserOutlined',
          id: 'testId3',
          link: 'https://support.logmycare.co.uk/en/collections/1681220-the-pro-plan',
          iconBackgroundColour: colors.purple,
          iconColour: colors.white,
        },
      ]}
      leftModuleCard={<EmarModuleCard />}
      rightModuleCard={<FamilyPlanModuleCard />}
      findOutMoreURL="https://logmycare.co.uk/features/care-delivery"
      customLinkText="Read more"
    />
  )
}

export const RiskAssessmentPaywall = RiskAssessmentPaywallComponent
